import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';
import '../Styles/destination.css';

export default class Cochin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'overview'
    };
  }

  render() {
    const attractions = [
      {
        name: "Fort Kochi",
        image: "/assets/img/fort-kochi.jpg",
        description: "A historic area known for its colonial architecture, charming streets, and the famous Chinese Fishing Nets. The area reflects a blend of Portuguese, Dutch, and British influences.",
        highlight: "Colonial Heritage",
        bestTime: "Morning/Evening",
        duration: "3-4 Hours",
        tip: "Take a walking tour to explore the heritage buildings"
      },
      {
        name: "Chinese Fishing Nets",
        image: "/assets/img/chinese-fishing-nets-bg.jpg",
        description: "Iconic cantilevered fishing nets believed to have been introduced by Chinese traders in the 14th century. They create a picturesque scene especially during sunset.",
        highlight: "Iconic Landmark",
        bestTime: "Sunset",
        duration: "1 Hour",
        tip: "Best viewed during sunset for stunning photos"
      },
      {
        name: "Mattancherry Palace",
        image: "/assets/img/mattancherry-palace.jpeg",
        description: "Also known as the Dutch Palace, this Portuguese palace features Kerala-style architecture with beautiful murals depicting Hindu temple art.",
        highlight: "Historic Palace",
        bestTime: "Morning",
        duration: "1-2 Hours",
        tip: "Closed on Fridays"
      },
      {
        name: "Jewish Synagogue",
        image: "/assets/img/jewish-synagogue.jpg",
        description: "The oldest active synagogue in the Commonwealth, built in 1568. It features Belgian chandeliers, hand-painted Chinese tiles, and ancient scrolls.",
        highlight: "Oldest Synagogue",
        bestTime: "Morning",
        duration: "1 Hour",
        tip: "Dress modestly, closed on Saturdays"
      },
      {
        name: "Marine Drive",
        image: "/assets/img/marine-drive.jpg",
        description: "A beautiful promenade along the backwaters, perfect for evening walks. The scenic walkway offers stunning views of the sunset and the Kochi skyline.",
        highlight: "Scenic Walkway",
        bestTime: "Evening",
        duration: "1-2 Hours",
        tip: "Perfect for sunset viewing"
      },
      {
        name: "St. Francis Church",
        image: "/assets/img/st-francis-church.jpg",
        description: "The oldest European church in India, built in 1503. Vasco da Gama was originally buried here before his remains were taken to Portugal.",
        highlight: "Oldest Church in India",
        bestTime: "Morning",
        duration: "45 mins",
        tip: "Visit the historical cemetery"
      },
      {
        name: "Kerala Kathakali Centre",
        image: "/assets/img/kathakali.jpeg",
        description: "Experience the traditional Kathakali dance performances with detailed makeup demonstrations. A must-visit for culture enthusiasts.",
        highlight: "Cultural Experience",
        bestTime: "Evening",
        duration: "2 Hours",
        tip: "Watch the makeup demonstration before the show"
      },
      {
        name: "Willingdon Island",
        image: "/assets/img/willingdon-island.jpg",
        description: "A man-made island created in the 1930s, now a major commercial center with luxury hotels, ports, and beautiful waterfront views.",
        highlight: "Man-made Island",
        bestTime: "All Day",
        duration: "2 Hours",
        tip: "Great for sunset views"
      }
    ];

    const experiences = [
      {
        title: "Heritage Walk",
        description: "Explore the colonial heritage of Fort Kochi through guided walking tours",
        icon: "fas fa-walking"
      },
      {
        title: "Kathakali Performance",
        description: "Witness the classical dance-drama with elaborate makeup and costumes",
        icon: "fas fa-mask"
      },
      {
        title: "Backwater Cruise",
        description: "Enjoy a relaxing boat ride through the scenic backwaters",
        icon: "fas fa-ship"
      },
      {
        title: "Spice Market Tour",
        description: "Discover Kerala's rich spice trade history at local markets",
        icon: "fas fa-seedling"
      }
    ];

    const quickInfo = [
      { label: "Location", value: "Ernakulam District, Kerala", icon: "fas fa-map-marker-alt" },
      { label: "Best Time to Visit", value: "October to March", icon: "fas fa-calendar-alt" },
      { label: "Nearest Airport", value: "Cochin International Airport (25 km)", icon: "fas fa-plane" },
      { label: "Nearest Railway", value: "Ernakulam Junction (1 km)", icon: "fas fa-train" },
      { label: "Famous For", value: "Chinese Fishing Nets, Backwaters, Spices", icon: "fas fa-fish" },
      { label: "Language", value: "Malayalam, English, Hindi", icon: "fas fa-language" }
    ];

    const culturalHighlights = [
      {
        name: "Jew Town",
        venue: "Mattancherry",
        description: "Explore the historic Jewish quarter with antique shops and the famous synagogue"
      },
      {
        name: "Biennale",
        month: "December-March",
        description: "The Kochi-Muziris Biennale - India's largest contemporary art exhibition"
      },
      {
        name: "Kochi Carnival",
        month: "December-January",
        description: "New Year celebrations with parades, music, and cultural events"
      }
    ];

    const culinaryDelights = [
      { name: "Malabar Parotta", description: "Layered flatbread served with spicy curry" },
      { name: "Kerala Sadya", description: "Traditional vegetarian feast on banana leaf" },
      { name: "Karimeen Pollichathu", description: "Pearl spot fish wrapped and grilled" },
      { name: "Kallu (Toddy)", description: "Local palm wine with fresh seafood" }
    ];

    return (
      <div className="dest-destination-page">
        {/* Hero Section */}
        <div className="destination-hero">
          <div className="dest-hero-overlay"></div>
          <div className="dest-hero-background">
            <img src="/assets/img/Cochin_Tour.png" alt="Kochi Backwaters" />
          </div>
          <div className="dest-hero-content">
            <div className="dest-hero-badge">
              <span>Queen of the Arabian Sea</span>
            </div>
            <h1 className="dest-hero-title">Kochi</h1>
            <p className="dest-hero-subtitle">
              Where history meets modernity, and cultures blend beautifully
            </p>
            <div className="dest-hero-location">
              <i className="fas fa-map-marker-alt"></i>
              <span>Ernakulam District, Kerala, India</span>
            </div>
          </div>
          <div className="dest-hero-scroll">
            <span>Scroll to explore</span>
            <i className="fas fa-chevron-down"></i>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="dest-intro-section">
          <Grid>
            <Row>
              <Col xs={12} md={7} className="dest-intro-text">
                <h2 className="dest-section-title">Welcome to Kochi</h2>
                <p className="dest-intro-description">
                  Kochi, also known as Cochin, is a vibrant city on the southwest coast of India. 
                  Often called the "Queen of the Arabian Sea," Kochi has been a major spice trading 
                  center for centuries, attracting traders from Arabia, China, Portugal, Holland, 
                  and Britain.
                </p>
                <p className="dest-intro-description">
                  The city is a fascinating blend of colonial heritage and modern development. 
                  From the iconic Chinese Fishing Nets of Fort Kochi to the bustling commercial 
                  district of Ernakulam, Kochi offers a unique mix of history, culture, and 
                  contemporary lifestyle.
                </p>
                <div className="dest-highlight-box">
                  <i className="fas fa-star"></i>
                  <span>Did You Know? Kochi is home to the oldest European church in India and the oldest active synagogue in the Commonwealth.</span>
                </div>
              </Col>
              <Col xs={12} md={5} className="dest-quick-info">
                <h3>Quick Facts</h3>
                <div className="dest-info-grid">
                  {quickInfo.map((info, index) => (
                    <div key={index} className="dest-info-card">
                      <div className="dest-info-icon">
                        <i className={info.icon}></i>
                      </div>
                      <div className="dest-info-content">
                        <span className="dest-info-label">{info.label}</span>
                        <span className="dest-info-value">{info.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Experiences Section */}
        <div className="dest-experiences-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Experiences in Kochi</h2>
            <p className="dest-section-subtitle">
              Unique ways to explore the cultural capital of Kerala
            </p>
          </div>
          <Grid>
            <Row className="experiences-grid">
              {experiences.map((exp, index) => (
                <Col xs={12} sm={6} md={3} key={index} className="experience-col">
                  <div className="experience-card">
                    <div className="exp-icon">
                      <i className={exp.icon}></i>
                    </div>
                    <h4 className="exp-title">{exp.title}</h4>
                    <p className="exp-description">{exp.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Attractions Section */}
        <div className="dest-attractions-section">
          <div className="dest-section-header">
            <h2 className="dest-section-title-centered">Top Attractions in Kochi</h2>
            <p className="dest-section-subtitle">
              Discover the iconic landmarks and cultural treasures
            </p>
          </div>

          <Grid>
            <Row className="dest-attractions-grid">
              {attractions.map((attraction, index) => (
                <Col xs={12} sm={6} md={4} lg={3} key={index} className="dest-attraction-col">
                  <div className="dest-attraction-card">
                    <div className="dest-card-image">
                      <img src={attraction.image} alt={attraction.name} />
                      <div className="dest-card-overlay">
                        <span className="dest-highlight-tag">{attraction.highlight}</span>
                      </div>
                    </div>
                    <div className="dest-card-content">
                      <h3 className="dest-attraction-name">{attraction.name}</h3>
                      <p className="dest-attraction-description">{attraction.description}</p>
                      <div className="dest-card-footer">
                        <div className="dest-time-info">
                          <span className="dest-best-time">
                            <i className="far fa-calendar"></i>
                            {attraction.bestTime}
                          </span>
                          <span className="dest-duration">
                            <i className="far fa-clock"></i>
                            {attraction.duration}
                          </span>
                        </div>
                        <div className="dest-travel-tip">
                          <i className="fas fa-lightbulb"></i>
                          <span>{attraction.tip}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Chinese Fishing Nets Section */}
        <div className="fishing-nets-section">
          <div className="fishing-nets-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="fishing-nets-content">
                <div className="fishing-nets-badge">Iconic Symbol</div>
                <h2 className="fishing-nets-title">The Chinese Fishing Nets</h2>
                <p className="fishing-nets-description">
                  The Chinese Fishing Nets (Cheena Vala) are the most recognizable symbol of Kochi. 
                  These massive cantilevered fishing nets, believed to have been introduced by Chinese 
                  traders from the court of Kublai Khan in the 14th century, create a spectacular 
                  silhouette against the sunset.
                </p>
                <p className="fishing-nets-description">
                  The nets are operated by a system of weights and counterweights, requiring a team 
                  of up to six fishermen to operate. Today, they remain functional and offer visitors 
                  a glimpse into the traditional fishing methods that have sustained coastal communities 
                  for centuries.
                </p>
                <div className="fishing-nets-tips">
                  <div className="tip">
                    <i className="fas fa-camera"></i>
                    <span>Best photography time: Sunset</span>
                  </div>
                  <div className="tip">
                    <i className="fas fa-clock"></i>
                    <span>Best time to visit: 4:00 PM - 6:30 PM</span>
                  </div>
                  <div className="tip">
                    <i className="fas fa-fish"></i>
                    <span>Watch fishermen operate the nets live</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Heritage Section */}
        <div className="heritage-section">
          <Grid>
            <Row>
              <Col xs={12} md={6} className="heritage-content">
                <div className="heritage-badge">Colonial Heritage</div>
                <h2 className="heritage-title">Fort Kochi: A Walk Through History</h2>
                <p className="heritage-description">
                  Fort Kochi is a living museum where Portuguese, Dutch, and British colonial 
                  architecture coexists with traditional Kerala buildings. The area's narrow streets 
                  are lined with heritage buildings, antique shops, art galleries, and charming cafes.
                </p>
                <p className="heritage-description">
                  The influence of various colonial powers is evident in the architecture - from 
                  Portuguese-built churches to Dutch-style houses and British-era bungalows. The 
                  area has been recognized as a heritage zone, preserving its unique character.
                </p>
                <div className="heritage-spots">
                  <div className="spot">
                    <i className="fas fa-church"></i>
                    <span>St. Francis Church (1503)</span>
                  </div>
                  <div className="spot">
                    <i className="fas fa-building"></i>
                    <span>Dutch Palace (1555)</span>
                  </div>
                  <div className="spot">
                    <i className="fas fa-synagogue"></i>
                    <span>Jewish Synagogue (1568)</span>
                  </div>
                  <div className="spot">
                    <i className="fas fa-landmark"></i>
                    <span>Santa Cruz Basilica (1505)</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Cultural Section */}
        <div className="cultural-section">
          <Grid>
            <div className="section-header">
              <h2 className="section-title-centered">Cultural Experiences</h2>
              <p className="section-subtitle">Immerse yourself in the rich cultural heritage</p>
            </div>
            <Row className="cultural-grid">
              {culturalHighlights.map((item, index) => (
                <Col xs={12} sm={6} md={4} key={index} className="cultural-col">
                  <div className="cultural-card">
                    <div className="cultural-icon">
                      <i className="fas fa-landmark"></i>
                    </div>
                    <h3 className="cultural-name">{item.name}</h3>
                    {item.venue && <p className="cultural-venue"><i className="fas fa-location-dot"></i> {item.venue}</p>}
                    {item.month && <p className="cultural-month"><i className="fas fa-calendar"></i> {item.month}</p>}
                    <p className="cultural-description">{item.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Grid>
        </div>

        {/* Culinary Section */}
        <div className="culinary-section">
          <div className="culinary-overlay"></div>
          <Grid>
            <Row>
              <Col xs={12} md={6} className="culinary-content">
                <div className="culinary-badge">Food Paradise</div>
                <h2 className="culinary-title">Culinary Delights of Kochi</h2>
                <p className="culinary-description">
                  Kochi is a food lover's paradise, offering a diverse range of culinary experiences 
                  influenced by its multicultural history. From traditional Kerala Sadya served on 
                  banana leaves to fresh seafood caught by the Chinese Fishing Nets, the city's food 
                  scene is vibrant and unforgettable.
                </p>
                <div className="culinary-list">
                  {culinaryDelights.map((item, index) => (
                    <div key={index} className="culinary-item">
                      <i className="fas fa-utensils"></i>
                      <div>
                        <strong>{item.name}</strong>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* Travel Tips Section */}
        <div className="dest-tips-section">
          <Grid>
            <div className="dest-section-header">
              <h2 className="dest-section-title-centered">Travel Tips for Kochi</h2>
              <p className="dest-section-subtitle">Make the most of your visit to the Queen of Arabian Sea</p>
            </div>
            <Row className="dest-tips-grid">
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-walking"></i>
                  </div>
                  <h4>Explore on Foot</h4>
                  <p>Fort Kochi is best explored on foot. Take a heritage walking tour to discover hidden gems</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <h4>Best Time</h4>
                  <p>Visit between October and March for pleasant weather and clear skies</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-ship"></i>
                  </div>
                  <h4>Backwater Cruise</h4>
                  <p>Don't miss the sunset cruise through the scenic backwaters</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3} className="dest-tip-col">
                <div className="dest-tip-card">
                  <div className="dest-tip-icon">
                    <i className="fas fa-shopping-bag"></i>
                  </div>
                  <h4>Shopping</h4>
                  <p>Explore Jew Town for antiques and spices. Bargaining is common</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>

        {/* CTA Section */}
        <div className="dest-cta-section">
          <div className="dest-cta-content">
            <h3>Experience the Magic of Kochi</h3>
            <p>Let us help you explore the cultural capital of Kerala</p>
            <Link to="/contact" className="dest-cta-button">
              Plan Your Trip
              <i className="fas fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}